import { Navigate, Outlet, type RouteObject } from 'react-router';

import UnprotectedRoute from 'src/components/UnprotectedRoute/UnprotectedRoute';

import LoginPage from '../pages/Login/LoginPage';
import SetPassword from '../pages/SetPassword/SetPassword.tsx';
import ForgotPassword from '../pages/ForgotPassword/ForgotPassword.tsx';
import TwoFAPage from '../pages/2FA/TwoFAPage.tsx';

export const loginRoutes: RouteObject = {
  element: (
    <UnprotectedRoute>
      <Outlet />
    </UnprotectedRoute>
  ),
  children: [
    {
      path: '/login',
      element: <LoginPage />,
    },
    {
      path: '/sso',
      element: <Navigate to="/login" replace />,
    },
  ],
};

export const authRoutes: RouteObject = {
  element: (
    <UnprotectedRoute>
      <Outlet />
    </UnprotectedRoute>
  ),
  children: [
    {
      path: '/forgot-password',
      element: <ForgotPassword />,
    },
    {
      path: '/set-password',
      element: <SetPassword />,
    },
    {
      path: '/auth/2fa',
      element: <TwoFAPage />,
    },
  ],
};
